import React from 'react';
import { Flex, Tag, TagLabel } from '@stockx/ui';
import { useTranslation } from 'react-i18next';

const TrendingDealFooter = ({ strikethroughAmount = '--' }) => {
  const { t } = useTranslation();
  return (
    <Flex mt="1">
      <Tag
        alignItems="center"
        pl="0"
        color="neutral.500"
        backgroundColor="neutral.white"
      >
        <TagLabel
          fontFamily="suisseIntlRegular"
          fontWeight="bold"
          fontSize="xs"
        >
          {`${t('Avg Sale')}:`}
        </TagLabel>
        <TagLabel
          paddingX={1}
          color="neutral.500"
          fontSize="sm"
          textDecoration={
            strikethroughAmount !== '--' ? 'line-through' : 'none'
          }
          textDecorationColor="neutral.600 !important"
          textDecorationThickness="0.1rem !important"
        >
          {strikethroughAmount}
        </TagLabel>
      </Tag>
    </Flex>
  );
};

export default TrendingDealFooter;
